/** 階段(木造) */
export const WOODEN_FLOORS = {
  UNSELECTED: '-1',
  ONE: '1',
  TWO: '2',
  OTHER: '9'
} as const
